// Global JavaScript for Digital Lab Empire Theme

// Cart functionality
class CartManager {
  constructor() {
    this.init();
  }

  init() {
    this.updateCartCount();
    this.setupCartListeners();
  }

  async updateCartCount() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      const cartCountElements = document.querySelectorAll('#cart-count, .cart-count');
      cartCountElements.forEach(el => {
        if (el) el.textContent = cart.item_count;
      });
    } catch (error) {
      console.error('Error updating cart count:', error);
    }
  }

  setupCartListeners() {
    // Listen for cart updates
    document.addEventListener('cart:updated', () => {
      this.updateCartCount();
    });
  }

  async addToCart(variantId, quantity = 1) {
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity
        })
      });

      if (response.ok) {
        const item = await response.json();
        document.dispatchEvent(new CustomEvent('cart:updated'));
        this.showNotification('Product added to cart!', 'success');
        return item;
      } else {
        const error = await response.json();
        this.showNotification(error.description || 'Error adding to cart', 'error');
        throw error;
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
      this.showNotification('Error adding to cart', 'error');
      throw error;
    }
  }

  showNotification(message, type = 'success') {
    const notification = document.createElement('div');
    notification.className = `fixed top-4 right-4 z-50 px-6 py-4 rounded-lg shadow-lg transform transition-all duration-300 ${
      type === 'success' ? 'bg-green-500' : 'bg-red-500'
    } text-white`;
    notification.textContent = message;
    
    document.body.appendChild(notification);
    
    setTimeout(() => {
      notification.classList.add('translate-x-full', 'opacity-0');
      setTimeout(() => notification.remove(), 300);
    }, 3000);
  }
}

// Initialize cart manager
const cartManager = new CartManager();

// Quick view functionality
function openQuickView(productHandle) {
  fetch(`/products/${productHandle}?view=quick`)
    .then(response => response.text())
    .then(html => {
      const modal = document.createElement('div');
      modal.className = 'fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4';
      modal.innerHTML = `
        <div class="bg-primary rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto relative">
          <button onclick="this.closest('.fixed').remove()" class="absolute top-4 right-4 text-white hover:text-accent transition-colors z-10">
            <svg class="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>
          ${html}
        </div>
      `;
      document.body.appendChild(modal);
    });
}

// Search functionality
const searchInput = document.querySelector('input[name="q"]');
if (searchInput) {
  let searchTimeout;
  searchInput.addEventListener('input', function() {
    clearTimeout(searchTimeout);
    const query = this.value;
    
    if (query.length > 2) {
      searchTimeout = setTimeout(() => {
        performSearch(query);
      }, 300);
    }
  });
}

async function performSearch(query) {
  try {
    const response = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}`);
    const data = await response.json();
    displaySearchResults(data);
  } catch (error) {
    console.error('Search error:', error);
  }
}

function displaySearchResults(data) {
  // Implement search results display
  console.log('Search results:', data);
}

// Lazy loading images
if ('IntersectionObserver' in window) {
  const imageObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const img = entry.target;
        if (img.dataset.src) {
          img.src = img.dataset.src;
          img.removeAttribute('data-src');
          observer.unobserve(img);
        }
      }
    });
  });

  document.querySelectorAll('img[data-src]').forEach(img => {
    imageObserver.observe(img);
  });
}

// Form validation
function validateForm(form) {
  const inputs = form.querySelectorAll('input[required], textarea[required]');
  let isValid = true;

  inputs.forEach(input => {
    if (!input.value.trim()) {
      isValid = false;
      input.classList.add('border-red-500');
    } else {
      input.classList.remove('border-red-500');
    }
  });

  return isValid;
}

// Add to cart function for product cards
async function addToCartFromCard(button) {
  const variantId = button.getAttribute('data-variant-id');
  
  if (!variantId) {
    console.error('Variant ID not found');
    alert('Error: Product variant not found');
    return;
  }

  // Disable button to prevent multiple clicks
  button.disabled = true;
  const originalText = button.textContent;
  button.textContent = 'Adding...';

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: parseInt(variantId),
        quantity: 1
      })
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.description || 'Failed to add product to cart');
    }

    const data = await response.json();
    
    // Update cart count using cartManager
    if (window.cartManager) {
      window.cartManager.updateCartCount();
      window.cartManager.showNotification('Product added to cart!', 'success');
    } else {
      // Fallback: Update cart count manually
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          const cartCountElements = document.querySelectorAll('#cart-count, .cart-count');
          cartCountElements.forEach(el => {
            if (el) el.textContent = cart.item_count;
          });
        });
      
      // Show notification
      alert('Product added to cart!');
    }

    // Dispatch cart updated event
    document.dispatchEvent(new CustomEvent('cart:updated'));
    
  } catch (error) {
    console.error('Error adding to cart:', error);
    alert(error.message || 'Error adding product to cart. Please try again.');
  } finally {
    // Re-enable button
    button.disabled = false;
    button.textContent = originalText;
  }
}

// Export for use in other scripts
window.CartManager = CartManager;
window.cartManager = cartManager;
window.openQuickView = openQuickView;
window.addToCartFromCard = addToCartFromCard;








